import type { StripeSubscription } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { getCurrentSubscription as getCurrentSubscriptionQuery } from "@/graphql/queries";

const client = generateClient();

export const currentSubscriptionState = create<State<StripeSubscription>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getCurrentSubscriptionIsloading = () =>
  currentSubscriptionState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const getCurrentSubscriptionIsError = (error: Error) =>
  currentSubscriptionState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const getCurrentSubscriptionIsSuccess = (
  listInvoices: StripeSubscription
) =>
  currentSubscriptionState.setState(() => ({
    data: listInvoices,
    isLoading: false,
    error: null,
  }));

export const getCurrentSubscription = async () => {
  getCurrentSubscriptionIsloading();

  try {
    const { data } = await client.graphql({
      query: getCurrentSubscriptionQuery,
    });

    getCurrentSubscriptionIsSuccess(data.getCurrentSubscription as StripeSubscription);
  } catch (e) {
    const errorMessage =
      e instanceof Error ? e.message : "failed to query get current subscription";
    getCurrentSubscriptionIsError(Error(errorMessage));
  }
};
